import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NGXLogger } from 'ngx-logger';
import { GET_COUPON_WITH_PRODUCTS } from '../../common/graphql/documents.graphql';
import { DataService } from './data/data.service';
import { isPlatformBrowser } from '@angular/common';
import { StateService } from './state/state.service';
import _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class PromoLinkResolver implements Resolve<any> {
  promoCode: string;
  storeIdentifier: string;
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private dataService: DataService,
    private router: Router,
    private logger: NGXLogger
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.promoCode = route.paramMap.get('promocode') || '';
    if (!isPlatformBrowser(this.platformId)) {
      return of(null);
    }
    return this.dataService
      .query(GET_COUPON_WITH_PRODUCTS, { code: this.promoCode, }, 'network-only')
      .pipe(
        map(result => {
          if(result?.promotionByPromoLinkCode) {
            return result?.promotionByPromoLinkCode;
          } else {
            this.logger.error(`PromoLinkResolver: Coupon not found for code '${this.promoCode}'`);
            this.router.navigateByUrl('/not-found', { skipLocationChange: true });
            return null;
          }
        }),
        catchError((err) => {
          this.logger.error(`PromoLinkResolver: Error ${err} fetching promotion for promocode '${this.promoCode}'`);
          this.router.navigateByUrl('/not-found', { skipLocationChange: true });
          return of(null);
        })
      );
  }
}
